import { Tabs, S3FileBrowser } from '@convergence/components';
import { FileBrowserSelectionType } from '@convergence/types';
import { useLabsQuery } from '../api/useLabsQuery';
import { fetch } from '../api/fetch';
import { useEffect } from 'react';
import { useStateLocalStorage } from '../hooks/useStateLocalStorage';

export type LabFileBrowserProps = {
  selection: {
    bucketId?: number;
    path: string;
    isFolder: boolean;
  }[];
  onSelectionChange: (
    v: {
      bucketId?: number;
      path: string;
      isFolder: boolean;
    }[],
    lab: { name: string; id: number }
  ) => void;
  pathType: FileBrowserSelectionType;
  initialPath?: string[];
  bucketId?: number;
  setBucketId: (bucketId: number) => void;
  path: string[];
  setPath: (path: string[]) => void;
  syncUrl?: boolean;
};

export const useLabFileBrowser = () => {
  const [fileBrowserState, setFileBrowserState] = useStateLocalStorage(
    'fileBrowser',
    {
      path: [] as string[],
      bucketId: null as number | null
    }
  );

  return {
    path: fileBrowserState.path,
    setPath: (path: string[]) =>
      setFileBrowserState({ ...fileBrowserState, path }),
    bucketId: fileBrowserState.bucketId ?? undefined,
    setBucketId: (bucketId: number) =>
      setFileBrowserState({ ...fileBrowserState, bucketId, path: [] })
  };
};

export function LabFileBrowser(props: LabFileBrowserProps) {
  // const [_path, _setPath] = useStateLocalStorage(
  //   'labFileBrowserPath',
  //   props.initialPath ?? []
  // );
  // const path = props.path ?? _path;
  // const [bucketId, setBucketId] = useState<number | null>(
  //   'labFileBrowserBucketId',
  //   props.bucketId ?? null
  // );

  // const setPath = props.setPath ?? _setPath;
  return (
    <LabFileBrowserControlled
      {...props}
      bucketId={props.bucketId}
      path={props.path}
      setPath={props.setPath}
    />
  );
}

function LabFileBrowserControlled(
  props: LabFileBrowserProps & {
    path: string[];
    setPath: (path: string[]) => void;
  }
) {
  const labsQuery = useLabsQuery();

  const tabItems =
    labsQuery.data?.labs.map((lab) => ({
      label: lab.name,
      value: lab.s3BucketId
    })) ?? [];

  useEffect(() => {
    if (tabItems?.length === 0) {
      return;
    }
    console.log(`Setting bucket to ${tabItems[0]?.value}`);
    const defaultBucketId = props.bucketId ?? tabItems[0]?.value;
    if (props.bucketId !== defaultBucketId && defaultBucketId) {
      props.setBucketId(defaultBucketId);
    }
  }, [tabItems]);

  if (labsQuery.error)
    return <div>Error loading labs: {labsQuery.error.message}</div>;

  if (!labsQuery.data?.labs) return <div>Loading labs...</div>;

  return (
    <Tabs
      defaultValue={props.bucketId ?? tabItems[0]?.value ?? 0}
      items={tabItems}
      onChange={(v) => {
        props.setPath([]);
        props.setBucketId(v as number);
      }}
      className="mb-4"
    >
      {labsQuery.data.labs.map((lab) => (
        <Tabs.Tab value={lab.s3BucketId}>
          <S3FileBrowser
            s3BucketId={lab.s3BucketId}
            fetch={fetch}
            className="h-full overflow-scroll"
            readOnly={false}
            path={props.path}
            setPath={props.setPath}
            selection={props.selection ?? []}
            selectionMode={props.pathType}
            onSelectionChange={(selection) => {
              props.onSelectionChange(selection, {
                name: lab.name,
                id: lab.id
              });
            }}
          />
        </Tabs.Tab>
      ))}
    </Tabs>
  );
}
